
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { AccountingPlanModel } from 'models/generated/Entities.Accounting.AccountingPlan';
import { LedgerPostModel } from 'models/generated/Entities.Accounting.LedgerPost';


const _accounting_AccountingPlanControllerHelper = new Map<string, Object>();
_accounting_AccountingPlanControllerHelper.set('GetAllAccountingPlans', AccountingPlanModel);
_accounting_AccountingPlanControllerHelper.set('GetAccountingPlan', AccountingPlanModel);
_accounting_AccountingPlanControllerHelper.set('GetAccountingPlansFromProductPlanId', AccountingPlanModel);
_accounting_AccountingPlanControllerHelper.set('GetAccountingPlansByStatus', AccountingPlanModel);
_accounting_AccountingPlanControllerHelper.set('Get', AccountingPlanModel);
_accounting_AccountingPlanControllerHelper.set('GetLatestOrFutureAccountingPlansFromProductPlanIds', AccountingPlanModel);
_accounting_AccountingPlanControllerHelper.set('GetCurrentAccountingPlansFromProductPlanIds', AccountingPlanModel);
_accounting_AccountingPlanControllerHelper.set('GetAccountingPlansFromProductPlanIds', AccountingPlanModel);
_accounting_AccountingPlanControllerHelper.set('GenerateSuggestedBillingPlanByInterval', LedgerPostModel);


export const accounting_AccountingPlanControllerHelper = _accounting_AccountingPlanControllerHelper;

